import axios from 'axios';
const env = window.env;

const HTTP = axios.create({
    baseURL: env.PROJECT_API_URL,
});

//interceptor becasue the store is not yet loaded.
HTTP.interceptors.request.use(
    function (config) {
        if (!config.headers['Accept-Language']) {
            //only set when not defined
            config.headers['Accept-Language'] = 'en'; //localStorage.getItem("appLanguage");
        }
        config.headers['Accept'] = 'application/json, text/plain';

        var token = localStorage.getItem('accessToken');
        if (token != null) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (err) {
        return Promise.reject(err);
    }
);
// Add a response interceptor
HTTP.interceptors.response.use(
    function (response) {
        if (response.data?.content) {
            //when returning lists
            return {
                data: response.data.content,
                count: response.data.totalElements,
            };
        }
        return {
            data: response.data,
            count: response.headers['x-total-count'],
        };
    },
    function (error) {
        return Promise.reject(error);
    }
);

/*
    Internal functions
    ===
*/

export async function getProjects({
    page = 0,
    itemsPerPage = 15,
    sort,
    order,
    includeArchived,
    fieldValues,
    searchTerm,
}) {
    var url = `/projects`;

    var searchParams = new URLSearchParams();
    searchParams.append('page', page);
    searchParams.append('size', itemsPerPage);

    if (sort && order) {
        searchParams.append('sort', `${sort},${order}`);
    }
    if (searchTerm) {
        searchParams.append('searchTerm', searchTerm);
    }

    return HTTP.put(`${url}?${decodeURIComponent(searchParams.toString())}`, {
        fieldValues: fieldValues,
        includeArchived: includeArchived,
    });
}

/*
    Currencies
    ===
*/
export async function getCurrency({ id }) {
    var url = `/api/currency/${id}`;
    return HTTP.get(url);
}

export async function getCurrencies({ page = 0, itemsPerPage = 15, sort, searchTerm }) {
    var url = `/api/currency/search`;
    var searchParams = new URLSearchParams();
    searchParams.append('page', page);
    searchParams.append('size', itemsPerPage);

    if (sort) {
        searchParams.append('sort', sort);
    }
    if (searchTerm) {
        searchParams.append('searchTerm', searchTerm);
    } else {
        searchParams.append('searchTerm', ' '); //needed for api to work
    }
    return HTTP.get(`${url}?${decodeURIComponent(searchParams.toString())}`);
}
